<template>
    <v-snackbar
        class="global-alert-notification-snackbar"
        v-model="stateGlobalAlert.show"
        :timeout="stateGlobalAlert.timeout"
        :color="stateGlobalAlert.type"
        location="top"
        min-width="auto"
    >
        <span
            class="text-body-large font-weight-bold d-flex"
            :class="alignClass"
            v-html="stateGlobalAlert.text"
        ></span>
        <!-- Custom Button -->
        <template
            v-if="stateGlobalAlert.link"
            #actions
        >
            <v-btn
                :color="stateGlobalAlert.link.color"
                variant="flat"
                :to="stateGlobalAlert.link.to"
            >
                {{ stateGlobalAlert.link.label }}
            </v-btn>
        </template>
        <!-- Reload Button -->
        <template
            v-else-if="stateGlobalAlert.showReloadButton"
            #actions
        >
            <v-btn
                color="rgb(var(--v-theme-on-secondary))"
                class="text-secondary"
                variant="flat"
                @click="router.go(0)"
            >
                Reload
            </v-btn>
        </template>
        <!-- Close Button -->
        <template
            v-else-if="stateGlobalAlert.showCloseButton"
            #actions
        >
            <v-btn
                color="rgb(var(--v-theme-on-secondary))"
                class="text-secondary"
                variant="flat"
                @click="stateGlobalAlert.show = false"
            >
                Close
            </v-btn>
        </template>
    </v-snackbar>
</template>

<script lang="ts" setup>
    import { GlobalAlertState } from '#x1-base/composables';
    const stateGlobalAlert = GlobalAlertState();
    const router = useRouter();
    const alignClass = computed(() => {
        return !stateGlobalAlert.value.showReloadButton && !stateGlobalAlert.value.showCloseButton && !stateGlobalAlert.value.link
            ? 'justify-center'
            : 'justify-start';
    });
</script>

<style lang="scss"></style>
